import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { getFollowUpDetail } from "reduxStore/action/followUpActions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { handleDetailResponse, isJSON, seo } from "utils/utils";
import { genderCheck } from "utils/constants";
import Breadcrumb from "component/common/breadcrumb";
const ViewFollowUp = () => {
  const navigate = useNavigate();
  const [viewData, setViewData] = useState({});
  const params = useParams();
  const { _id = "" } = params || {};
  const dispatch = useDispatch();

  const followupDetailSelector = useSelector((state) => state.followUp) || {};
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    if (followupDetailSelector.detail) {
      const { response } = followupDetailSelector;
      if (response?.status === 200) {
        let office_address = {},
          result = {
            ...handleDetailResponse(response.data),
            ...handleDetailResponse(response.data)?.customer,
          };
        let typeofaddress = typeof result?.office_address;
        if (typeofaddress === "string" || typeofaddress === "object") {
          office_address =
            typeofaddress === "object"
              ? result?.office_address
              : isJSON(result?.office_address)
                ? JSON.parse(result?.office_address)
                : null;
          // result.customer_detail = { ...result?.customer_detail, office_address: office_address }
        }
        setViewData({ ...result, office_address: office_address });
      }
    }
  }, [followupDetailSelector]);

  useEffect(() => {
    dispatch(getFollowUpDetail({ followup_id: _id }));
  }, []);
  useEffect(() => {
    seo({
      title: "Followup Details",
      metaDescription: "Followup details",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.viewfollowupDetails}
        url={"/followup"}
        parentListing={strings.followupList}
        titleactive={strings.viewfollowupdetails}
        isBackBtn={true}
      />

      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.followupDetails}</h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.propertyName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.property_title || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.lastInteracted}{" "}
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {moment(viewData?.followup_date).format("DD-MM-yyyy") ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.source} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.created_name || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row ">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.status} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.followup_status_title ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.propertyRequired}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.configuration} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.configuration || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.Area} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.areain_sqlft || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.budget} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {/* {viewData?.min_budget && viewData?.max_budget
                          ? `${viewData?.min_budget}${viewData?.min_budget_type} - ${viewData?.max_budget}${viewData?.max_budget_type}`
                          : strings.notavailable} */}

                        {viewData?.budget_amount
                          ? viewData?.budget_amount
                          : viewData?.min_budget &&
                            viewData?.max_budget
                          ? `${viewData?.min_budget}${viewData?.min_budget_type} - ${viewData?.max_budget}${viewData?.max_budget_type}`
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.natureOfFunding}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.funding_type || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.purpose}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.purpose || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.customerDetails}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.visitorName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {`${viewData?.customer?.first_name || ""} ${viewData?.customer?.last_name || ""}`.trim() || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.mobileNo} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer?.mobile}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.location} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer?.location || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.age} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        27
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.gender} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {genderCheck[viewData?.customer?.gender] ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.companyDetails}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.nameOfOccupation}{" "}
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer?.occupation || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.companyName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer?.coumpany_name ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.designation}{" "}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer?.desigantion ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.officeAddress}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer?.office_address ||
                          strings.notavailable}
                      </label>
                      {/* {viewData?.office_address ? <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.office_address?.house_no}
                        {","}
                        {viewData?.office_address?.area}
                        {","}
                        {viewData?.office_address?.landmark}
                        {","}
                        {viewData?.office_address?.location}
                        {","}
                        {viewData?.office_address?.pincode}
                      </label> : strings.notavailable} */}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    {/* <div className="col-md-6 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="submit"
                          onClick={() => {
                            navigatpage("/appointment");
                          }}
                        >
                          {strings.scheduleSiteVisit}
                        </button>
                      </div>
                    </div> */}
                    <div className="col-md-12 text-center">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="submit"
                          onClick={() => {
                            navigatpage(
                              `/updatestatusfollow/${viewData?.lead_id}`
                            );
                          }}
                        >
                          {strings.statusUpdate}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewFollowUp;
